import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

/**
 * Returns a copy of the financing body with one field replaced. The override helpers address their
 * fields through `FINANCING_COST_OVERRIDES`, and a computed key cannot be spread into a typed
 * object literal, so the field is written on the copy instead.
 */
export function withFinancingBodyField<TKey extends keyof SaveSaleVehicleFinancingBody>(
  body: SaveSaleVehicleFinancingBody,
  key: TKey,
  value: SaveSaleVehicleFinancingBody[TKey]
) {
  const next = {...body};
  next[key] = value;

  return next;
}
